import Accordion from "react-bootstrap/Accordion";
import styles from "../../../../styles/Poll.module.scss";

function CompletedPolls({ completedPolls }) {
  return (
    <>
      {!completedPolls.length && (
        <h6 className="text-center mt-5">No completed polls available</h6>
      )}
      <Accordion defaultActiveKey={0} className="mb-2">
        {completedPolls &&
          completedPolls.map((item, i) => (
            <Accordion.Item eventKey={i} key={i}>
              <Accordion.Header>{item.survey.name}</Accordion.Header>
              <Accordion.Body>
                {item?.survey?.questions?.map((data, i) => (
                  <div key={i}>
                    Q: {data.question.question}
                    <div>
                      Response:
                      <ul className={styles.surveyResponse}>
                        {data.question?.choices.map((choice, i) => (
                          <li key={i}>
                            {choice.choice}
                            <span className="ms-4">
                              {choice.result_percent + "%"}
                            </span>
                          </li>
                        ))}
                        <hr />
                      </ul>
                    </div>
                  </div>
                ))}
              </Accordion.Body>
            </Accordion.Item>
          ))}
      </Accordion>
    </>
  );
}

export default CompletedPolls;
